import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, OnInit, output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs/operators';
import { DepthUnit, DrawingShape } from '../../../../core';
import { GetDefaultDepthUnit, IsCubic, IsImperial, IsSquare, IsYard } from '../../../../core/functions';

@Component({
    selector: 'app-take-off-drawing-depth',
    templateUrl: './take-off-drawing-depth.component.html',
    styleUrls: ['./take-off-drawing-depth.component.scss'],
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TakeOffDrawingDepthComponent implements OnInit {
    shape = input('');
    unit = input('');
    depth = input(0);
    depthUnit = input('');

    depthChanges = output<number>();
    depthUnitChanges = output<string>();

    isDepthEnabled = computed(() => this.checkIsDepthEnabled(this.unit(), this.shape()));
    title = computed(() => (IsCubic(this.unit()) ? 'Depth' : 'Height'));

    depthUnits = computed(() =>
        IsImperial(this.unit()) || IsYard(this.unit()) ? [DepthUnit.ft] : [DepthUnit.mm, DepthUnit.cm, DepthUnit.m]
    );

    readonly #fb = inject(FormBuilder);
    depthUnitForm?: FormGroup;

    ngOnInit(): void {
        this.initdepthUnitForm();
    }

    private initdepthUnitForm() {
        this.depthUnitForm = this.#fb.group({
            depth: [this.depth(), { updateOn: 'blur' }],
            depthUnit: [this.depthUnit() || this.getDepthUnit()],
        });

        this.depthUnitChanges.emit(this.depthUnitForm.controls['depthUnit']?.value);

        this.depthUnitForm.controls['depth']?.valueChanges.pipe(distinctUntilChanged()).subscribe((depth: number) => {
            this.depthChanges.emit(depth);
        });

        this.depthUnitForm.controls['depthUnit']?.valueChanges.subscribe((depthUnit: string) => {
            this.depthUnitChanges.emit(depthUnit);
        });
    }

    private checkIsDepthEnabled(unit: string, shape: string): boolean {
        return IsCubic(unit) || (IsSquare(unit) && shape === DrawingShape.Line);
    }

    private getDepthUnit(): string {
        if (IsImperial(this.unit()) || IsYard(this.unit())) {
            return DepthUnit.ft;
        }

        return this.depthUnit() || GetDefaultDepthUnit(this.unit());
    }
}
